import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { TooltipProvider } from '@/components/ui/tooltip';
import { ThemeProvider } from '@/components/theme-provider';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider, useAuth } from './hooks/useAuth';
import Layout from './components/layout/Layout';
import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import ForcePasswordChangePage from './pages/ForcePasswordChangePage';
import DashboardPage from './pages/DashboardPage';
import RFQListPage from './pages/RFQListPage';
import RFQDetailPage from './pages/RFQDetailPage';
import RFQCreatePage from './pages/RFQCreatePage';
import ClientsPage from './pages/ClientsPage';
import AdminPage from './pages/AdminPage';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center text-muted-foreground">
        A carregar...
      </div>
    );
  }
  if (!user) return <Navigate to="/login" />;
  // CRIT-06: enquanto a conta exigir mudança de password, bloqueamos toda a
  // app e mostramos apenas o ecrã de alteração (o backend também bloqueia
  // todos os endpoints excepto /auth/me e /auth/change-password).
  if (user.must_change_password) return <ForcePasswordChangePage />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index element={<DashboardPage />} />
        <Route path="rfqs" element={<RFQListPage />} />
        <Route path="rfqs/new" element={<RFQCreatePage />} />
        <Route path="rfqs/:id" element={<RFQDetailPage />} />
        <Route path="clients" element={<ClientsPage />} />
        <Route path="admin" element={<AdminPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <TooltipProvider delayDuration={200}>
        <AuthProvider>
          <BrowserRouter>
            <AppRoutes />
            <Toaster />
          </BrowserRouter>
        </AuthProvider>
      </TooltipProvider>
    </ThemeProvider>
  );
}
